import { render, staticRenderFns } from "./SuForm.vue?vue&type=template&id=0c730178&scoped=true&"
import script from "./SuForm.vue?vue&type=script&lang=js&"
export * from "./SuForm.vue?vue&type=script&lang=js&"
import style0 from "./SuForm.vue?vue&type=style&index=0&id=0c730178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c730178",
  null
  
)

export default component.exports